'use client'

import { Button } from '@/core/ui/atoms/button'
import { FormTextArea } from '@/core/ui/forms/text-area'
import { Star } from 'lucide-react'
import { Controller } from 'react-hook-form'
import { ProductDetails } from '../../model/product.model'
import { useAddReview } from './use-add-review'
import { useTranslations } from 'next-intl'

type Props = {
  product: ProductDetails
  onClose: () => void
}
export const AddReview: React.FC<Props> = ({ onClose, product }) => {
  const { form, handleSubmit, isPending } = useAddReview({
    productSlug: product.slug,
    productId: product.id,
    onSuccess: onClose,
  })
  const t = useTranslations()
  return (
    <form onSubmit={handleSubmit} className='px-1 py-3 sm:px-10 sm:py-5'>
      <h2 className='mb-2 text-xl font-semibold sm:mb-4 sm:text-2xl'>
        {t('reviews.addReview')}
      </h2>

      <Controller
        name='rate'
        control={form.control}
        render={({ field }) => (
          <div className='mb-4 flex sm:mb-2'>
            {[1, 2, 3, 4, 5].map(star => (
              <button
                key={star}
                type='button'
                onClick={() => field.onChange(star)}
                className='cursor-pointer focus:outline-none'
              >
                <Star
                  className={`text-xl transition-colors sm:h-7 sm:w-7 ${field.value >= star ? 'fill-creamed-cron text-creamed-cron' : 'text-gray-300'}`}
                />
              </button>
            ))}
          </div>
        )}
      />

      <FormTextArea
        control={form.control}
        name='comment'
        label={t('reviews.Write a review')}
        placeholder={t('reviews.writeHere')}
        rows={4}
      />

      <Button loading={isPending} className='mt-1 h-11 w-full'>
        Submit review
      </Button>
    </form>
  )
}
